module.exports = __webpack_public_path__ + "img/dc2df1b.jpg";